import * as React from "react"
import {formatPercentage} from "@ui-seeker/utils";
import {Box} from "@mui/material";

import {ArrowBackground} from "@components";


export default function changesColumn() {
	return [{
		name: 'changeDirection', label: 'Change Direction',
		options: { display: 'excluded' }
	}, {
		name: 'diff', label: '% Change',
		options: {
			filter: false,
			customBodyRowRender: (value, { currentPrice, prevPrice }) => <Box sx={{ textAlign: 'center' }}>
				<ArrowBackground
					value={currentPrice}
					prev={prevPrice}
					backgroundColor={value > 0 ? 'success.light' : 'error.light'}
				>
					{formatPercentage(value, { decimals: 2 })}
				</ArrowBackground>
			</Box>
		}
	}]
}